import React from 'react';
import LegalDoc from '../components/LegalDoc';

/* KVKK Aydınlatma Metni. İçerik `translations[lang].dataProtection`.
   Rota adı kardeş projeyle (crm-whowsell /data-protection) ve bu
   projedeki İngilizce rota diliyle uyumlu olsun diye İngilizce. */
export default function DataProtectionPage() {
  return <LegalDoc sozlukAnahtari="dataProtection" parlaklikRengi="rgba(16, 185, 129, 0.3)" />;
}
